import { IMAGES } from './links';

export const bonuses = [
  {
    number: 1,
    title: 'The Intelligent Sensory Intake Guide™',
    value: '$37',
    image: IMAGES.bonus1,
    intro: [
      'The questions you ask at the beginning of a case can influence the information you have available later.',
      'I created this guide to help you organize the questions that may be relevant when exploring sensory modulation concerns.',
    ],
    items: [
      'Functional concern prompts.',
      'Developmental history questions.',
      'Daily routine questions.',
      'Environmental context prompts.',
      'Family observation questions.',
      'School participation questions.',
      'Sensory-related observation prompts.',
      'Explanations of why each area may matter.',
    ],
    closing: 'The goal isn’t to collect as much information as possible. It’s to help you organize relevant information and identify areas that may need further exploration.',
  },
  {
    number: 2,
    title: 'The 15-Minute Sensory Case Organizer™',
    value: '$37',
    image: IMAGES.bonus2,
    intro: [
      'When information is scattered across different notes, even a familiar case can feel difficult to organize.',
      'This printable worksheet helps you bring the main elements together in one place.',
    ],
    items: [
      'A case overview template.',
      'A functional concern worksheet.',
      'An observation and context matrix.',
      'A missing information filter.',
      'A working hypothesis organizer.',
      'A next-question planning sheet.',
    ],
    closing: 'A focused 15-minute organization exercise — without the need to review an entire library of theory first.',
  },
  {
    number: 3,
    title: 'The Sensory Modulation Clinical Glossary™',
    value: '$27',
    image: IMAGES.bonus3,
    intro: [
      'A practical visual reference for key concepts and terminology related to sensory modulation and clinical reasoning.',
      'You’ll receive concise explanations of:',
    ],
    items: [
      'Sensory modulation.',
      'Sensory processing.',
      'Observable behavior.',
      'Functional participation.',
      'Contextual factors.',
      'Working hypotheses.',
      'Alternative explanations.',
      'Clinical reasoning terminology.',
    ],
    closing: 'The glossary is designed as an educational reference, not a diagnostic classification system. Keep it nearby whenever you need a quick reminder of a concept while organizing your notes.',
  },
  {
    number: 4,
    title: '10 Sensory Modulation Case Reasoning Challenges™',
    value: '$29',
    image: IMAGES.bonus4,
    intro: [
      'The best way to become familiar with a reasoning framework is to practice using it.',
      'Ten fictional educational scenarios designed to help you apply the pathway. For each scenario, you’ll explore:',
    ],
    items: [
      'What do you actually observe?',
      'What information is available?',
      'What information is missing?',
      'Which contextual factors deserve consideration?',
      'What alternative explanations might be relevant?',
      'What questions could you investigate next?',
      'What functional impact should you explore?',
    ],
    closing: 'Each challenge includes reflection prompts and an educational review guide. The purpose isn’t to memorize a single correct answer — it’s to practice organizing your thinking and recognizing uncertainty.',
  },
  {
    number: 5,
    title: 'The Clinical Progress & Functional Goal Tracker™',
    value: '$17',
    image: IMAGES.bonus5,
    intro: [
      'Once you’ve organized a case, you also need a way to document meaningful functional information over time.',
      'This collection of printable tools helps you organize:',
    ],
    items: [
      'Functional goals.',
      'Baseline information.',
      'Observable changes.',
      'Activity participation.',
      'Progress review.',
      'Session observations.',
      'Family communication.',
      'Goal revision.',
    ],
    closing: 'The purpose is to support clearer documentation of functional outcomes, not to attribute every change automatically to sensory modulation.',
  },
];
